<template>
    <div class="mt-5 mx-2">
        <div class="w-full px-4">
            <CheckSVG></CheckSVG>
            {{ $t('component.facts.fact1') }}
        </div>
        <div class="w-full px-4">
            <CheckSVG></CheckSVG>
            {{ $t('component.facts.fact2') }}
        </div>
        <div class="w-full px-4">
            <CheckSVG></CheckSVG>
            {{ $t('component.facts.fact3') }}
        </div>
        <div class="w-full px-4">
            <CheckSVG></CheckSVG>
            {{ $t('component.facts.fact4') }}
        </div>
        <div class="w-full px-4">
            <div class="text-right underline cursor-pointer"
                 @click="$router.push({ name : 'info' })">
                {{ $t('component.facts.more') }}
            </div>
        </div>
    </div>
</template>

<script>
    import CheckSVG from "@/components/shared/svgs/CheckSVG";
    export default {
        name: "Facts",
        components: {CheckSVG}
    }
</script>

<style scoped>

</style>